var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ShopStar"},_vm._l((_vm.count),function(i){return _c('div',[(i <= _vm.num)?_c('img',{staticClass:"star",attrs:{"src":require("@/assets/shop/Star.png"),"alt":""}}):_c('img',{staticClass:"star",attrs:{"src":require("@/assets/shop/Star_gray.png"),"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }